











import {computed, defineComponent, PropType, ref} from "@vue/composition-api";
import ParameterNameGenerator from "@tool/Helpers/ParameterNameGenerator";
import {ProjectBuilderSettingsInterface, ParameterType} from "@tool/tool.types";
import useBuilderStore from "@tool/store/useBuilderStore";

export default defineComponent({
    emits: ['add'],
    props: {
        existingParameters: {
            type: Array as PropType<{ type: 'template' | 'manual'; name: string; }[]>,
            required: true
        },
        type: {
            type: String as PropType<ParameterType>,
            required: true
        },
    },
    setup(props, {emit}) {

      const {projectBuilderSettings} = useBuilderStore();

        const value = ref<string>('');

        const formattedValue = computed<string>(() => {
            return ParameterNameGenerator(value.value, projectBuilderSettings.value);
        });

        const disableInput = computed<boolean>(() => {
            return formattedValue.value === '' ||
                    props.existingParameters.findIndex(
                            parameter => parameter.name === formattedValue.value
                    ) !== -1;
        });

        const onSubmit = () => {
            emit('add', props.type, formattedValue.value);
            value.value = '';
        }

        return {
            value,
            disableInput,
            onSubmit,
            formattedValue,
        }
    },
})
